import React, { useContext } from 'react';
import LogicContext from './LogicContext';

const Help = () => {
  const context = useContext(LogicContext);
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-2 d-inline-block "
  }, /*#__PURE__*/React.createElement("h4", null, "Help"), !context && /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, "Language - Declarations of non-logical symbols:"), /*#__PURE__*/React.createElement("ul", {
    className: "fs-sm"
  }, /*#__PURE__*/React.createElement("li", null, "Symbols declarations must be comma-separated"), /*#__PURE__*/React.createElement("li", null, "A constant declaration is just the constant symbol"), /*#__PURE__*/React.createElement("li", null, "A function or predicate symbol declaration has the form symbol/arity (e.g. f/1)"))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, "Proof - Alternative ways of writing logical symbols:"), /*#__PURE__*/React.createElement("ul", {
    className: "fs-sm"
  }, /*#__PURE__*/React.createElement("li", null, "Disjunction: \u2228, ||, |, \\/"), /*#__PURE__*/React.createElement("li", null, "Negation: \xAC, -, !, ~"), /*#__PURE__*/React.createElement("li", null, "Substitution: \u21A6, ->, \u27FC, |-> or (var, term)"), /*#__PURE__*/React.createElement("li", null, "Empty clause: \u25A1, \u25AB\uFE0E, \u25FD\uFE0E, \u25FB\uFE0E, \u2B1C\uFE0E, \u25A2, \u22A5, [], _|_"))));
};

export default Help;